import React from 'react';
import { useNavigate } from 'react-router';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';

import { SearchStringProvider, useSearchString } from '@barboxx/admin-utils';
import { Can } from '@barboxx/react-utils';

import {
    CustomPageHeader,
    RootContainer,
} from '../../components/nav/RootContainer';
import PlacesTable from './components/PlacesTable';

function PlacesListCard() {
    const navigate = useNavigate();
    const { InputComponent, searchString } = useSearchString();

    const CustomPageToolbarComponent = React.useCallback(
        () => (
            <CustomPageHeader>
                <Box gap={2} flexDirection="row" display="flex">
                    <InputComponent />
                    <Can I="create" a="Place">
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                                navigate('create');
                            }}
                        >
                            Add Place
                        </Button>
                    </Can>
                </Box>
            </CustomPageHeader>
        ),
        [InputComponent, navigate]
    );

    return (
        <RootContainer
            maxWidth={false}
            slots={{ header: CustomPageToolbarComponent }}
        >
            <PlacesTable searchString={searchString} />
        </RootContainer>
    );
}

export function PlacesList() {
    return (
        <SearchStringProvider>
            <PlacesListCard />
        </SearchStringProvider>
    );
}
